import { styled } from '@mui/material';

const StyledMaxWidthPageImage = styled('img')(({ theme }) => ({
	maxWidth: '100%',
	width: '100%',
	marginBlock: '24px',
	borderRadius: '10px',
	objectFit: 'none',

	pointerEvents: 'none',

	[theme.breakpoints.down('md')]: {
		objectFit: 'cover',
	},

	[theme.breakpoints.down('sm')]: {
		marginBlock: '16px',
		borderRadius: '0px',
	},
}));

export default StyledMaxWidthPageImage;
